/* TTS PDP (2026-09): product page buy box behaviour (snippets/main-product__info-blocks.liquid).
   - On every variant change the theme fetches the section HTML and publishes
     PUB_SUB_EVENTS.variantChange with it; the size tiles, fit row and "Utolsó pár" line live
     inside <product-variant-selects> and are re-rendered by the theme itself. Here we copy the
     parts outside it: the trust list (TtsTrust-<section>) and the payment line (TtsPayNote-<section>),
     and announce "Utolsó pár" through the polite live region (TtsPdpLive-<section>).
   - "Más méret kellene?" (button, only when a size is sold out) moves focus to the first
     crossed-out size, so the shopper can pick it and subscribe with the back-in-stock form. */
(function () {
  'use strict';

  if (window.TTSPdpBuybox) return;
  window.TTSPdpBuybox = { version: 1 };

  function copyFrom(html, id) {
    var source = html.getElementById(id);
    var destination = document.getElementById(id);
    if (!source || !destination) return;
    destination.innerHTML = source.innerHTML;
    destination.hidden = source.hidden;
  }

  function announce(sectionId, text) {
    var live = document.getElementById('TtsPdpLive-' + sectionId);
    if (!live) return;
    live.textContent = '';
    if (!text) return;
    window.setTimeout(function () {
      live.textContent = text;
    }, 60);
  }

  function onVariantChange(event) {
    var data = event && event.data;
    if (!data || !data.html || !data.sectionId) return;
    var id = data.sectionId;
    copyFrom(data.html, 'TtsTrust-' + id);
    copyFrom(data.html, 'TtsPayNote-' + id);

    var last = data.html.getElementById('TtsLastPair-' + id);
    announce(id, last ? last.textContent.replace(/\s+/g, ' ').trim() : '');
  }

  function bind() {
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
    subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
  }

  function onOtherSizeClick(event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-tts-other-size]') : null;
    if (!button) return;
    event.preventDefault();

    var root = button.closest('product-info') || document;
    var input = root.querySelector('.tts-size .product-option__input.visually-disabled');
    var hintId = button.getAttribute('aria-controls');
    var hint = hintId ? document.getElementById(hintId) : null;

    if (hint) {
      hint.hidden = false;
      button.setAttribute('aria-expanded', 'true');
    }

    var section = root.getAttribute && root.getAttribute('data-section');
    if (section && hint) announce(section, hint.textContent.replace(/\s+/g, ' ').trim());

    if (!input) return;

    var label = input.id ? root.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(input.id) : input.id) + '"]') : null;
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    (label || input).scrollIntoView({ block: 'center', behavior: reduceMotion ? 'auto' : 'smooth' });

    try {
      input.focus({ preventScroll: true });
    } catch (e) {
      input.focus();
    }

    if (label) {
      label.classList.add('tts-size-tile--hint');
      window.setTimeout(function () {
        label.classList.remove('tts-size-tile--hint');
      }, 2400);
    }
  }

  document.addEventListener('click', onOtherSizeClick);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
